(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/single-receiver.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/single-receiver.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.SingleReceiver = Marionette.View.extend({
    className: 'grassroots',
    templateContext: {
      isCorporateSite: svs.grassroots.data.config.isCorporateSite,
      grassrootsChooseClub: svs.grassroots.data.config.grassrootsChooseClub
    },
    template: function(data) {
      return svs.grassroots.templates.single_receiver(data);
    },
    ui: {
      link: 'textarea'
    },
    regions: {
      grassrootsStats: '#grassroots-stats'
    },
    events: {
      'click .js-remove-support-btn': 'removeSupport',
      'click .js-add-support-btn': 'addSupport',
      'click .js-copy-link': 'copyLink',
      'click .expandable-box-header-yearlystatistics': 'toggleAllYearlystatistics'
    },
    modelEvents: {
      change: 'render'
    },
    initialize: function() {
      this.listenTo(
        svs.grassroots.models.single_receiver,
        'change',
        this.render
      );
      if (this.getOption('add')) {
        this.addSupport();
      }
    },

    addSupport: function() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.grassroots.collections.my_receivers.addSupport(this.model, this.el);
      } else {
        svs.grassroots.router.navigate(Backbone.history.fragment + '?add=add', {
          silent: true
        });
        svs.components.customer_login.login();
      }
      return false;
    },

    removeSupport: function() {
      svs.grassroots.collections.my_receivers.removeSupport(this.model);
    },

    copyLink: function() {
      var copySupported = document.queryCommandSupported('copy');

      this.ui.link.select();
      if (copySupported) {
        document.execCommand('copy');
        svs.grassroots.helpers.dialog.infoToaster({
          autoClose: svs.grassroots.helpers.dialog.autoClose.SHORT,
          title: 'Kopierad',
          message: 'Koden är kopierad till urklipp.'
        });
      }
    },
    toggleAllYearlystatistics: function(e) {
      if (e.currentTarget.innerText === 'Visa fler') {
        e.currentTarget.innerText = 'Visa färre';
      } else {
        e.currentTarget.innerText = 'Visa fler';
      }
      return true;
    }
  });
})(Backbone, _, svs);


 })(window);